/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./popPromptTwo.vue?vue&type=template&id=7c4163d0&scoped=true"
import script from "./popPromptTwo.vue?vue&type=script&lang=js"
export * from "./popPromptTwo.vue?vue&type=script&lang=js"
import style0 from "./popPromptTwo.vue?vue&type=style&index=0&id=7c4163d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c4163d0",
  null
  
)

export default component.exports